// SidebarFooterLogo.tsx
import * as React from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

interface SidebarFooterLogoProps {
    isCollapsed: boolean
}

export const SidebarFooterLogo: React.FC<SidebarFooterLogoProps> = ({
    isCollapsed,
}) => {
    const { t } = useTranslation('translations')

    const logoClassname = classNames(
        'absolute bottom-1/2 left-0 translate-y-1/2 w-[150px] transition-all',
        {
            'mb-[48px] !bottom-0 !left-[-12px]': isCollapsed,
        }
    )

    const logoGridClassname = classNames({
        'grid-cols-[1fr_auto]': !isCollapsed,
        'grid-cols-[0fr_auto]': isCollapsed,
    })

    return (
        <div className="relative grow">
            <div className={logoClassname}>
                <div className="flex">
                    <div
                        className={`grid transition-all ${logoGridClassname}`}
                        data-testid="label-with-content"
                    >
                        <div className="overflow-hidden">
                            <div
                                className="whitespace-nowrap text-xs"
                                data-testid="label-with-content-text"
                            >
                                {t('sidebar_menu.powered_by')}
                            </div>
                        </div>

                        <div
                            className="flex items-center pl-2 pr-2"
                            data-testid="label-with-content-children"
                        >
                            <img
                                data-testid="logo"
                                src="/assets/thg-logo.png"
                                className="block h-4 w-auto"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
